var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-single-nav"},[_c('Author',{attrs:{"uid":_vm.uid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }